interface NavPair {
    index: number;
    wrapper: Element | undefined;
    trigger: HTMLButtonElement | null;
    subNav: Element | null;
    subIsOpen: boolean;
}

class DesktopMenu {
    openClass: string;
    navPairs: NavPair[];
    currentlyOpen: NavPair | null;

    currentlyOpenDropdownDesktop: string | null;
    openClassDesktop: string;

    constructor() {
        this.navPairs = [];
        this.openClass = "sub-menu-open";
        this.currentlyOpen = null;

        this.currentlyOpenDropdownDesktop = null;
        this.openClassDesktop = "dropdown__button--open";

        document
            .querySelectorAll(".menu-item-has-children")
            .forEach((element, index) => {
                const pair = {
                    index: index,
                    wrapper: element,
                    trigger: element.querySelector("button"),
                    subNav: element.querySelector(".sub-menu"),
                    subIsOpen: false,
                };

                this.navPairs.push(pair);
            });

        this.addListeners();
    }

    addListeners() {
        for (const pair of this.navPairs) {
            pair.trigger?.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopImmediatePropagation();

                if (this.currentlyOpen == null) {
                    this.openSubNav(pair);
                } else {
                    if (pair.index === this.currentlyOpen.index) {
                        this.closeSubNav(this.currentlyOpen);
                    } else {
                        this.closeSubNav(this.currentlyOpen);
                        this.openSubNav(pair);
                    }
                }
            });
        }

        document.querySelector("body")?.addEventListener("click", () => {
            if (this.currentlyOpen != null)
                this.closeSubNav(this.currentlyOpen);

            if (this.currentlyOpenDropdownDesktop !== null) {
                this.closeDropdownDesktop(this.currentlyOpenDropdownDesktop);
            }
        });

        document
            .querySelectorAll(
                ".js-header-dropdown-button-desktop, .js-header-dropdown-button-desktop i",
            )
            ?.forEach((button) => {
                button.addEventListener("click", (e) => {
                    e.stopPropagation(); // Needed since the event fires twice (due to our querySelectorAll) when clicking the <i>
                    let name;

                    if ((e.target as HTMLElement).tagName === "I") {
                        // Clicked icon
                        name = (
                            e.target as HTMLElement
                        ).parentElement!.attributes.getNamedItem(
                            "data-dropdown-button",
                        )!.value;
                    } else {
                        // Clicked button itself
                        name = (
                            e.target as HTMLButtonElement
                        ).attributes.getNamedItem(
                            "data-dropdown-button",
                        )!.value;
                    }

                    if (this.currentlyOpenDropdownDesktop === null) {
                        this.openDropdownDesktop(name);
                    } else if (this.currentlyOpenDropdownDesktop === name) {
                        this.closeDropdownDesktop(name);
                    } else {
                        this.closeDropdownDesktop(this.currentlyOpenDropdownDesktop);
                        this.openDropdownDesktop(name);
                    }
                });
            });
    }

    openSubNav(pair: NavPair | null) {
        pair?.wrapper?.classList.add(this.openClass);
        this.currentlyOpen = pair;
    }

    closeSubNav(pair: NavPair | null) {
        pair?.wrapper?.classList.remove(this.openClass);
        this.currentlyOpen = null;
    }

    openDropdownDesktop(name: string) {
        // Timeout to enable body click listener to close and avoid race conditions
        setTimeout(() => {
            const button = document.querySelector(
                `[data-dropdown-button="${name}"]`,
            );

            button?.classList.add(this.openClassDesktop);
            button?.setAttribute("aria-expanded", "true");
            this.currentlyOpenDropdownDesktop = name;
        }, 0);
    }

    closeDropdownDesktop(name: string) {
        const button = document.querySelector(
            `[data-dropdown-button="${name}"]`,
        );

        button?.classList.remove(this.openClassDesktop);
        button?.setAttribute("aria-expanded", "false");
        this.currentlyOpenDropdownDesktop = null;
    }
}
export default DesktopMenu;
